export default {
    priorAuthNumber: 'WEB123456789',
    errorMessage: null,
    message: 'Mock Create PA Success'
}